export default {"src":"/_next/static/media/mobileMenuClose.6c351676.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};